import { ui } from '@procuros/datachecks';
import set from 'lodash/set';

import { ColumnTypesInternal } from 'components/DataTable/Types';

import { groupRowsByMainRecord } from './grouping';
import { transformValue } from './helpers';
import { transformGroupedRows } from './transformation';
import { ColumnMetadata } from './types';

export const dataTransformer = (
  sheets: Record<string, Array<Record<string, unknown>>>,
  mainSheetName: string,
  metadata: ColumnMetadata,
  expectedDataFormats: Record<string, ui.FieldTypes>,
): Array<Record<string, unknown>> => {
  const mainSheet = sheets[mainSheetName];
  if (!sheets || !mainSheet || mainSheet.length === 0) {
    return [];
  }

  if (metadata.embeddedTableGroups.length === 0) {
    return mainSheet.map((row) => {
      const transformedRow: Record<string, unknown> = {
        _internal: { [ColumnTypesInternal.procuros_added]: true },
      };

      for (const [key, value] of Object.entries(row)) {
        const expectedFormat = expectedDataFormats[key];
        const transformedValue = transformValue(value, expectedFormat, sheets, key);
        set(transformedRow, key, transformedValue);
      }

      return transformedRow;
    });
  }

  const groupedRows = groupRowsByMainRecord(mainSheet, metadata.mainColumns);

  return transformGroupedRows(groupedRows, metadata, sheets);
};

export type { ColumnMetadata } from './types';
